import { render, staticRenderFns } from "./AddAcount.vue?vue&type=template&id=62ec6576&scoped=true&"
import script from "./AddAcount.vue?vue&type=script&lang=ts&"
export * from "./AddAcount.vue?vue&type=script&lang=ts&"
import style0 from "./AddAcount.vue?vue&type=style&index=0&id=62ec6576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec6576",
  null
  
)

export default component.exports